import { Button, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { axiosInstance } from "../../utils/axiosInterceptor";
import HeaderCompo from "../../component/Header";
import { render } from "@testing-library/react";
import "./rebatestatement.css"
import { FileTextOutlined } from "@ant-design/icons";
const RebateStatement = () => {
  const currentUTCDate = new Date(
    Date.UTC(
      new Date().getUTCFullYear(),
      new Date().getUTCMonth(),
      new Date().getUTCDate(),
    ),
  );
  const userInfo = useSelector((state) => state.userAuth.decodedToken.user);
  const SelectedPharmacy = useSelector((state) => {
    return state.pharmacyData?.pharmacyData;
  });
  const [rebateStateMents, setRebateStatements] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [userAccounts, setUserAccounts] = useState([]);
  const [allUserFetched, setAllUserFetched] = useState(false);

  const getRebateStatment = async () => {
    if (!selectedAccounts || selectedAccounts?.length === 0) return;
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `api/v2/account/get-rebate?accountNumber=${selectedAccounts}`,
      );
      setRebateStatements(response?.data?.reports);
    } catch (err) {
      console.error("Error fetching accounts:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const updatePharmacies = (value) => {
    setSelectedAccounts(value);
  };
  const getDisplayPharmacy = (account) => {
    const isGoodUser = userInfo?.user_roles_id === 5;

    if (isGoodUser && account?.acct_id === 96167) {
      return {
        ...account,
        displayName: "ABC Pharmacy",
        displayId: "123456",
      };
    }
    return {
      ...account,
      displayId: account.acct_id,
      displayName: account.name || account.label,
    };
  };

  const getApiVersionByDate = (date) => {
    if (!date) return "v2";
    const sep2025 = new Date("2025-09-01");
    const selectedDate = new Date(date);

    return selectedDate < sep2025 ? "" : "api/v2/";
  };

  function formatDate(date) {
    const d = new Date(date);
    const year = d.getUTCFullYear();
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const day = String(d.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  useEffect(() => {
    const fetchUserAccounts = async () => {
      const formattedFromDate = formatDate(currentUTCDate);
      const apiVersion = getApiVersionByDate(formattedFromDate);
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(
          `/${apiVersion}users/accounts?email=${userInfo?.email}`,
        );
        // console.log("response", response.data.data.data);
        setUserAccounts(response.data.data.data);
        setAllUserFetched(true);
      } catch (error) {
        console.error("Error:", error);
      }finally{
        setIsLoading(false);
      }
    };
    fetchUserAccounts();
  }, []);
  useEffect(() => {
    getRebateStatment();
  }, [selectedAccounts]);
  useEffect(() => {
    if (!allUserFetched) return; // wait for fetch
    if (userAccounts.length > 0 && selectedAccounts?.length === 0) {
      const specialUser = userAccounts.find((user) => user.acct_id === 96167);
      if (specialUser) {
        setSelectedAccounts([specialUser?.acct_id]);
      } else {
        setSelectedAccounts([userAccounts[0]?.acct_id]);
      }
    }
  }, [userAccounts, selectedAccounts, allUserFetched]);

  function formatMonthYearUTC(value) {
    if (!value) return "";

    const match = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(value);
    if (!match) return value;

    const [, year, month] = match;

    const date = new Date(Date.UTC(Number(year), Number(month) - 1, 1));

    const monthName = new Intl.DateTimeFormat("en-US", {
      month: "long",
      timeZone: "UTC",
    }).format(date);

    return `${monthName} ${year}`;
  }
  const rebateColumns = [
  {
    title: "MONTH",
    dataIndex: "rebateMonth",
    key: "rebateMonth",
    render: (value) => (
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-[#E7FBF7] flex items-center justify-center">
          <FileTextOutlined
            style={{
              color: "#14B8A6",
              fontSize: 16,
            }}
          />
        </div>

        <span className="font-medium text-[#243B53]">
          {formatMonthYearUTC(value)}
        </span>
      </div>
    ),
  },

  {
    title: "ACTIONS",
    dataIndex: "url",
    key: "url",
    align: "right",

    render: (url) => (
      <Button
        type="default"
        className="rounded-lg h-9 px-5"
        onClick={() => window.open(url, "_blank")}
      >
        View
      </Button>
    ),
  },
];
  return (
    <div>
      <HeaderCompo initialColor={"#000833"} />
      <div className="m-6">
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 w-full md:w-auto">
          <Select
            // mode="tags"
            value={selectedAccounts}
            onChange={updatePharmacies}
            className="w-full md:w-[400px] "
            style={{
              // width: "400px",
              border: "1px solid #d9d9d9",
              "border-radius": "6px",
            }}
            placeholder="Select accounts"
            options={userAccounts?.map((account) => {
              // label: account.name || account.label,
              // value: account.acct_id || account.acct_id,
              // key: account.acct_id,
              const modified = getDisplayPharmacy(account);
              return {
                label: `${modified.displayName} (${modified.displayId || account.acct_id})`,
                value: account.acct_id,
                key: account.acct_id,
                displayId: modified.displayId,
              };
            })}
            showSearch
            filterOption={(input, option) => {
              const search = input.toLowerCase();
              const label = (option?.label ?? "").toString().toLowerCase();
              const value = (option?.value ?? "").toString().toLowerCase();
              const displayId = (option?.displayId ?? "")
                .toString()
                .toLowerCase();
              return (
                label.includes(search) ||
                displayId.includes(search) || // allows search by 123456
                value.includes(search) // fallback (96167 if needed)
              );
            }}
            // maxTagCount={3}
          />
        </div>
        <div className="mt-6 bg-white rounded-xl border border-[#E8EDF5] overflow-hidden shadow-sm">
  <div className="px-6 py-5 border-b border-[#EEF2F7]">
    <h2 className="text-[20px] font-semibold text-[#14213D] m-0">
      Rebate Statements
    </h2>
  </div>

  <Table
    loading={loading}
    columns={rebateColumns}
    dataSource={rebateStateMents}
    pagination={false}
    rowKey="rebateMonth"
    className="rebate-table"
    locale={{
      emptyText: "No rebate statements found",
    }}
    footer={() => (
      <div className="flex justify-between text-[#8B97A8] text-xs">
      </div>
    )}
  />
</div>
      </div>
    </div>
  );
};

export default RebateStatement;
